module.exports = __webpack_public_path__ + "img/delivery-bg-2.34dbaff7.jpg";